import { t } from '@/i18n';
import type { ExportDirective, ExportFilter, ExportFormat } from '@/shared/export/types';
import { TEAM_ROLE_FILTERS, teamStatusLabel } from '../constants/team.constants';
import type { TeamFilters } from '../types/team.types';

/** Nombre de archivo del PDF de Equipo (BF-641). */
export const TEAM_PDF_FILENAME = 'reporte_equipo.pdf';
export const TEAM_XLSX_FILENAME = 'reporte_equipo.xlsx';

export interface TeamExportInput {
  filters: TeamFilters;
  companyName: string;
  companyId: string;
  customerId?: string | null;
}

function roleLabel(value: string): string {
  const option = TEAM_ROLE_FILTERS.find((item) => item.value === value);
  return option ? t(option.labelKey) : value;
}

function statusLabel(value: string): string {
  return teamStatusLabel(value);
}

/**
 * Construye el directive de export del PDF de Equipo (BF-641): manda los
 * filtros aplicados ya resueltos a label/value para el encabezado del reporte.
 */
export function buildTeamExportDirective(input: TeamExportInput, format: ExportFormat = 'pdf'): ExportDirective {
  const filters: ExportFilter[] = [];

  const search = input.filters.search?.trim();
  if (search) filters.push({ label: t('team.filters.emailLabel'), value: search });
  if (input.filters.role) {
    filters.push({ label: t('team.filters.roleLabel'), value: roleLabel(input.filters.role) });
  }
  if (input.filters.status) {
    filters.push({ label: t('team.filters.statusLabel'), value: statusLabel(input.filters.status) });
  }

  return {
    report: 'team',
    format,
    companyName: input.companyName,
    companyId: input.companyId,
    customerId: input.customerId ?? null,
    filters,
  };
}
